import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, Subscription, zip } from 'rxjs';
import { AuthService } from './core/auth/service/auth.service';
import { BaseService } from './core/base-service/service';
import {
	RoleListServicePathConst,
	RoleMenuServicePathConst,
	RoleMyAccessServicePathConst,
} from './layout/shared/const/service-path.const';
import { RoleAccessModel, RoleModel } from './layout/shared/model';
import { RoleMenuModel } from './layout/shared/model/role-menu.model';
import { RoleAccessService } from './layout/shared/service';

@Component({
	selector: 'app-root',
	template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, OnDestroy {
	private subscribers: Subscription[];

	constructor(
		private authService: AuthService,
		private location: Location,
		private roleAccessService: RoleAccessService,
		private baseService: BaseService
	) {}

	ngOnInit(): void {
		this.subscribers = [];

		const isRedirecting = this.location.path().startsWith('/redirect');

		if (!isRedirecting) {
			this.fetchAllUserConfigs();
		}
	}

	fetchAllUserConfigs(): void {
		this.fetchSidebarNavigation();
		// this.fetchSidebarNavigationNonAdmin();
		this.fetchUserCurrentRole();
		this.fetchAccessService();
	}

	private fetchAccessService(): void {
		const subs = this.baseService
			.getData(RoleMyAccessServicePathConst, RoleAccessModel, null, true)
			.subscribe((resp: RoleAccessModel[]) => {
				this.authService.roleAccesses = resp.map((value) => {
					return value.code.toLowerCase();
				});
				this.roleAccessService.setRoleAccess(resp);
			});

		this.subscribers.push(subs);
	}

	// private fetchSidebarNavigation(): void {
	// 	const adminMenuId = localStorage.getItem('EMRAdmin.menuId');
	// 	const nonAdminMenuId = '43b059f7-2351-4ef4-8e77-4bbf67f5fc80';

	// 	const urlAdmin =
	// 		RoleMenuServicePathConst + '?parentID=' + adminMenuId + '&isSideBar=true';
	// 	const urlNonAdmin =
	// 		RoleMenuServicePathConst + '?parentID=' + nonAdminMenuId + '&isSideBar=true';

	// 	const adminReq = this.baseService.getData(urlAdmin, RoleMenuModel, null, true);
	// 	const nonAdminReq = this.baseService.getData(urlNonAdmin, RoleMenuModel, null, true);

	// 	const subs = forkJoin([adminReq, nonAdminReq]).subscribe(
	// 		([adminResp, nonAdminResp]: [RoleMenuModel[] | null, RoleMenuModel[] | null]) => {
	// 		  const safeAdmin = adminResp ?? [];
	// 		  const safeNonAdmin = nonAdminResp ?? [];
	// 		  this.authService.menuTrees = [...safeAdmin, ...safeNonAdmin];
	// 		  console.log('this.authService.menuTrees: ', this.authService.menuTrees)
	// 		}
	// 	);

	// 	this.subscribers.push(subs);
	// }

	private fetchSidebarNavigation(): void {
		const adminMenuId = localStorage.getItem('EMRAdmin.menuId');
		const nonAdminMenuId = '43b059f7-2351-4ef4-8e77-4bbf67f5fc80';

		const urlAdmin =
			RoleMenuServicePathConst + '?parentID=' + adminMenuId + '&isSideBar=true';
		const urlNonAdmin =
			RoleMenuServicePathConst +
			'?parentID=' +
			nonAdminMenuId +
			'&isSideBar=true';

		const adminReq = this.baseService.getData(
			urlAdmin,
			RoleMenuModel,
			null,
			true
		);
		const nonAdminReq = this.baseService.getData(
			urlNonAdmin,
			RoleMenuModel,
			null,
			true
		);

		if (adminMenuId == '25b3a171-82bf-4985-8b4a-0dbd5fae9e66') {
			const subs = forkJoin([adminReq, nonAdminReq]).subscribe(
				([adminResp, nonAdminResp]: [
					RoleMenuModel[] | null,
					RoleMenuModel[] | null
				]) => {
					const safeAdmin = adminResp ?? [];
					const safeNonAdmin = nonAdminResp ?? [];

					this.authService.menuTrees = [...safeAdmin, ...safeNonAdmin];
				}
			);

			this.subscribers.push(subs);
		} else {
			const subs = this.baseService
				.getData(urlAdmin, RoleMenuModel, null, true)
				.subscribe((resp: RoleMenuModel[]) => {
					this.authService.menuTrees = resp;
				});

			this.subscribers.push(subs);
		}
	}

	private fetchUserCurrentRole(): void {
		const roles: string[] = JSON.parse(localStorage.getItem('EMRAdmin.roles'));

		const authorizedMenuIds: Set<string> = new Set();

		const mappedRoles = roles.map((role) => {
			const url = RoleListServicePathConst + '/' + role;

			return this.baseService.getData(url, RoleModel);
		});

		const subs = zip(...mappedRoles).subscribe({
			next: (responses: RoleModel[]) => {
				responses.forEach((response) =>
					response.menus.forEach(authorizedMenuIds.add, authorizedMenuIds)
				);
				this.authService.authorizedMenuIds = Array.from(authorizedMenuIds);
			},
		});

		this.subscribers.push(subs);
	}

	ngOnDestroy(): void {
		this.subscribers.forEach((each) => each.unsubscribe());
	}
}
